<template>
    <div class="search-main-symptom-wrapper">

        <div class="search-main-symptom--input-container">

            <!-- We need the v-if on this text field in order to trigger autofocus each time the Search dialog is open. That's the only purpose of the v-if on this text field. -->
            <v-text-field
                v-if="getMustShowChooseMainSymptomPopup"
                v-model="searchSymptomInputValue"
                :placeholder="text('api.chatbot.placeholder.searchSymptom')"
                ref="searchMainSymptomInput"
                id="searchMainSymptomInput"
                prepend-icon="search"
                :append-icon="(searchSymptomInputValue && searchSymptomInputValue.length > 0) ? 'clear' : ''"
                :append-icon-cb="clearSearch"
                class="chatbot-search-input-main-symptom"
                type="text"
                autofocus
                solo
                flat
                @focus="handleInputFocus"
                @blur="handleInputBlur"
            ></v-text-field>

        </div>

        <div class="search-main-symptom--results-container">
            <div v-if="searchSymptomInputValue.length > 0 && getSearchSymptomResultList && getSearchSymptomResultList.length === 0 && !isLoadingSearchMainSymptom"
                 class="container-no-search-results color-body">
                <p class="info-no-results">
                    {{text("api.chatbot.mainSymptom.search.noResults")}}
                </p>
            </div>
            <div v-if="isLoadingSearchMainSymptom && searchSymptomInputValue.length > 0 && getSearchSymptomResultList && getSearchSymptomResultList.length === 0 "
                 class="container-no-search-results color-body">
                <p class="info-no-results">
                    {{text("api.chatbot.mainSymptom.search.searching")}}
                </p>
            </div>
            <main-symptom-list v-if="getSearchSymptomResultList && getSearchSymptomResultList.length > 0"
                               :symptoms="getSearchSymptomResultList"
                               :selectedMainSymptomCode="crtSelectedMainSymptomCode"
                               symptomListSourceType="SEARCH"
                               @onMainSymptomSelected="handleMainSymptomSelected"
            ></main-symptom-list>
        </div>

        <div class="search-main-symptom--confirm-btn-container confirm-selected-main-symptom">
            <btn-confirm-main-symptom v-if="getSearchSymptomResultList && getSearchSymptomResultList.length > 0"
                                      :isVisible="getSearchSymptomResultList && getSearchSymptomResultList.length > 0"
                                      :crtSelectedMainSymptom="crtSelectedMainSymptom"
                                      symptomSourceType="SEARCH"
                                      @onMainSymptomConfirmed="handleMainSymptomConfirmed"
            ></btn-confirm-main-symptom>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>

import {mapGetters} from 'vuex';
import MainSymptomList from "./MainSymptomList";
import BtnConfirmMainSymptom from "./BtnConfirmMainSymptom";
import Vue from "vue";

export default {
        name: 'SearchMainSymptom',
        components: {
            MainSymptomList,
            BtnConfirmMainSymptom
        },
        data() {
            return {
                isLoadingSearchMainSymptom: false,
                searchSymptomInputValue: '',
                crtSelectedMainSymptom: null,
                searchRedPfPlugin: Vue.SearchRedPf.searchRedPfSvg,
                clearRedPfPlugin: Vue.ClearRedPf.clearRedPfSvg,
            }
        },

        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getMustShowChooseMainSymptomPopup: 'ChatBotStore/getMustShowChooseMainSymptomPopup',
                getSearchSymptomResultList: 'ChatBotStore/getSearchSymptomResultList',
            }),
            crtSelectedMainSymptomCode() {
                if (this.crtSelectedMainSymptom !== null && typeof this.crtSelectedMainSymptom !== 'undefined') {
                    return this.crtSelectedMainSymptom.code;
                }
                else {
                    return "";
                }
            }
        },

        mounted() {
            // Set properly coloured search (magnifier) icon on Search Main Symptom input.
            // Here on "mounted" event we only take care about "search (magnifier)" icon, because the
            // "clear search" icon is added to the page only when the user enters text in search input,
            // so we set color on "clear search" icon on onchange event for Search Main Symptom input.
            // let colorTheme = this.getAppPropertyValue('GUI_THEME_COLOR');
            let iconSearchMagnifier = document.querySelector(".choose-main-symptom-popup .search-main-symptom--input-container .input-group__input .input-group__prepend-icon");
            if (iconSearchMagnifier !== null) {
                iconSearchMagnifier.innerHTML = this.searchRedPfPlugin();
            }

            // Compute and set the popup height values.
            this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
        },
        beforeDestroy() {
            this.clearSearch();
        },
        watch: {
            searchSymptomInputValue(newVal, oldVal) {
                this.isLoadingSearchMainSymptom = true;
                this.UtilitiesPlugin.debounce(this.handleInputSearchChanged, 200)();
            },

        },
        methods: {
            disableScroll() {
                let that = this;

                window.onscroll = function() {
                    console.log("Window pageYOffset", window.pageYOffset);
                    if ( window.innerHeight < window.outerHeight / 2  ) {
                        that.UtilitiesPlugin.smoothScrollTo( window.pageYOffset - 1);
                    }

                };
            },
            enableScroll() {
                window.onscroll = function() {};
            },
            handleMainSymptomSelected(selectedSymptom) {
                this.crtSelectedMainSymptom = selectedSymptom;
            },
            handleInputSearchChanged() {

                if (this.searchSymptomInputValue !== null && this.searchSymptomInputValue.length > 0) {

                    setTimeout(() => {
                        let iconClearSearch = document.querySelector(".choose-main-symptom-popup .search-main-symptom--input-container .input-group__input i.input-group__append-icon");
                        if (iconClearSearch !== null) {
                            iconClearSearch.innerHTML = this.clearRedPfPlugin();
                            iconClearSearch.style.display = "initial";
                        }
                    }, 200);

                    this.$store.dispatch('ChatBotStore/submitSearchMainSymptom', {
                        searchedText: this.searchSymptomInputValue
                    }).then(() => {
                        this.isLoadingSearchMainSymptom = false;
                        this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                    }).catch(() => {
                        this.isLoadingSearchMainSymptom = false;
                    })

                }
                else {
                    this.clearSearch();
                }

            },

            handleMainSymptomConfirmed() {
                this.clearSearch();

                let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
                rootElement.classList.remove('hide-scroll');

                // Close "Choose Main Symptom" popup.
                this.$store.commit("ChatBotStore/setMustShowChooseMainSymptomPopup", false);

                this.PfChatbotPlugin.handleAnswerClick();
            },


            clearSearch() {
                this.searchSymptomInputValue = '';
                this.crtSelectedMainSymptom = null;
                this.$store.commit('ChatBotStore/clearSearchSymptomResultList');
            },

            // Visual Viewport keyboard fix start

            createOverlay(options = {}) {
                const {
                    zIndex = 201,
                    id = 'chooseMainSymptomKeyboardOverlay'
                } = options;

                const overlay = document.createElement('div');
                overlay.id = id;
                overlay.style.position = 'fixed';
                overlay.style.top = '0';
                overlay.style.left = '0';
                overlay.style.width = '100%';
                overlay.style.height = '100%';
                overlay.style.zIndex = zIndex;

                const alreadyOverlay = document.getElementById("chooseMainSymptomKeyboardOverlay");
                if (alreadyOverlay) {
                    return null;
                }
                const app = document.getElementById("app");
                app.appendChild(overlay);
                return overlay;
            },

            fit() {
                const vv = window.visualViewport;
                const dialog = document.querySelector('.dialog__content.dialog__content__active');
                dialog.style.top = `${vv.offsetTop}px`;
                dialog.style.transition = "none";
            },

            handleInputFocus() {
                const vv = window.visualViewport;
                if (this.PfChatbotChooseMainSymptomPlugin.shouldApplyKeyboardFix()) {
                    vv.addEventListener('scroll', this.fit);
                    this.fit();
                    this.createOverlay();
                    this.$nextTick(function () {
                        this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                    });
                }
            },

            handleInputBlur() {
                const vv = window.visualViewport;
                if (this.PfChatbotChooseMainSymptomPlugin.shouldApplyKeyboardFix()) {
                    vv.removeEventListener('scroll', this.fit)
                    const dialog = document.querySelector('.dialog__content.dialog__content__active');
                    dialog.style.top = "0";
                    dialog.style.transition = ".3s ease-in-out";
                    this.$nextTick(function () {
                        this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                    });

                    const overlay = document.getElementById("chooseMainSymptomKeyboardOverlay");
                    if (overlay) {
                        overlay.remove();
                    }
                }
            }

            // Visual Viewport Keyboard end
        }
    }

</script>

<!-- ################################################################## -->

<style lang="scss">

#chooseMainSymptomKeyboardOverlay {
    background-color: $color-block-background;
}

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/main-symptom-popup/SearchMainSymptom.vue